import React, { FC } from 'react';

import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { ARRAY_INDEX } from 'enums';
import style from 'views/components/UI/Breadcrumbs/Breadcrumbs.module.scss';
import { Text } from 'views/components/UI/Text';

interface ICrumb {
  id: number;
  path: string;
  name: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

interface IBreadcrumbsProps {
  pathname: string;
  title?: string;
  crumbs?: ICrumb[] | null;
}

const Breadcrumbs: FC<IBreadcrumbsProps> = props => {
  const { pathname, title, crumbs } = props;
  const pathsArr = pathname.split('/');
  const paths = pathsArr[ARRAY_INDEX.ZERO] === '' ? pathsArr.slice(1, -1) : pathsArr;
  const shouldRenderCrumbs = Boolean(crumbs?.length && crumbs.length > 1);
  const isLast = (index: number): boolean => index === crumbs!.length - 1;

  return (
    <>
      {paths.length === 1 && !shouldRenderCrumbs ? (
        <Text variant="bodySmall" color="var(--sk-text-subtle)">
          {title}
        </Text>
      ) : (
        <nav>
          <ul className={style.breadcrumbs}>
            {crumbs?.map((crumb, i) => {
              const handleClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
                if (isLast(i)) {
                  e.preventDefault();
                }

                crumb.onClick?.(e);
              };
              return (
                <li key={crumb.id}>
                  <Link
                    to={{
                      pathname: crumb.path,
                    }}
                    className={classNames(style.crumb, {
                      [style.disabled]: isLast(i),
                    })}
                    onClick={handleClick}
                  >
                    {crumb.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      )}
    </>
  );
};

export { Breadcrumbs };
